import React from "react";

/** Top Achievers public privacy policy (external site). */
export const TOP_ACHIEVERS_PRIVACY_POLICY_URL = "https://topachieversplano.org/privacy-policy";

/**
 * COPPA privacy statement + mandatory parent/guardian consent checkbox.
 * Used when a parent creates a family profile (Event Calendar sign-up).
 */
export default function CoppaPrivacyConsentBlock({
  checked = false,
  onChange,
  checkboxId = "coppa-privacy-consent",
  privacyPolicyUrl = TOP_ACHIEVERS_PRIVACY_POLICY_URL,
}) {
  return (
    <div className="coppa-privacy-consent">
      <h4 className="coppa-privacy-consent__title">Your Privacy Matters</h4>
      <p className="coppa-privacy-consent__text">
        Top Achievers collects information you provide here — including your contact details and your child&apos;s
        profile information (such as name, date of birth, and race/ethnicity) — to enroll your child, communicate
        with your family, and report program outcomes to our funders and partners. We do not sell this information, and
        we share it only when necessary to run the program (e.g., school partners, grant reporting) or as required by
        law.
      </p>
      <p className="coppa-privacy-consent__text">
        If your child is under 13, the Children&apos;s Online Privacy Protection Act (COPPA) gives you the right to:
      </p>
      <ul className="coppa-privacy-consent__list">
        <li>Review the personal information we&apos;ve collected about your child</li>
        <li>Request that we delete your child&apos;s information</li>
        <li>Refuse to allow us to collect or use any further information about your child</li>
      </ul>
      <p className="coppa-privacy-consent__text">
        To exercise these rights or ask questions, contact us at{" "}
        <a href="tel:+14695730928">469-573-0928</a> or{" "}
        <a href="mailto:info@topachieversplano.org">info@topachieversplano.org</a>. We will never sell your
        information.
      </p>
      <p className="coppa-privacy-consent__text">
        By creating this profile, you confirm you are the parent or legal guardian and consent to the collection and
        use of your and your child&apos;s information as described here and in our full{" "}
        <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        .
      </p>
      <label className="coppa-privacy-consent__checkbox" htmlFor={checkboxId}>
        <input
          id={checkboxId}
          type="checkbox"
          checked={!!checked}
          onChange={(e) => onChange && onChange(e.target.checked)}
        />
        <span>
          I have read the privacy statement above and consent to the collection and use of my and my child&apos;s
          information as described.
        </span>
      </label>
    </div>
  );
}
